export interface IEnvironmentPictureType {
    SituationPlan?: number
    GRBMap?: number
    Water?: number
    FloorPlan?: number
    Birdseye?: number
    MapWithPOI?: number
    Landuse?: number
    RightOfPreemption?: number
    CombinedMaps?: number
    Heritage?: number
    OVAM?: number
    FloorPlan2?: number
    Cadastral?: number
}

export class EnvironmentPictureType implements IEnvironmentPictureType {
    SituationPlan: number
    GRBMap: number
    Water: number
    FloorPlan: number
    Birdseye: number
    MapWithPOI: number
    Landuse: number
    RightOfPreemption: number
    CombinedMaps: number
    Heritage: number
    OVAM: number
    FloorPlan2: number
    Cadastral: number

    constructor(option: IEnvironmentPictureType) {
        this.SituationPlan = option.SituationPlan || 1
        this.GRBMap = option.GRBMap || 2
        this.Water = option.Water || 3
        this.FloorPlan = option.FloorPlan || 4
        this.Birdseye = option.Birdseye || 5
        this.MapWithPOI = option.MapWithPOI || 6
        this.Landuse = option.Landuse || 7
        this.RightOfPreemption = option.RightOfPreemption || 8
        this.CombinedMaps = option.CombinedMaps || 9
        this.Heritage = option.Heritage || 10
        this.OVAM = option.OVAM || 11
        this.FloorPlan2 = option.FloorPlan2 || 12
        this.Cadastral = option.Cadastral || 13
    }
}